// extracted by mini-css-extract-plugin
export default {"shared":"\"../shared.module.css\"","lg":"992px","container":"RemainingBoxes_container__khjCD","boxContainer":"RemainingBoxes_boxContainer__0-NTW"};